const UI_FIELDS_CATEGORIES = Object.freeze({
  OPEN: {
    ADDRESS: 21,
    DEMOGRAPHICS: 52,
    PERSON_INFO: 34,
    BUSINESS_INFO: 22,
    EMPLOYMENT: 28,
    EMPLOYMENT_HISTORY: {
      EMPLOYMENT_HISTORY: 77,
      EMPLOYED: 101,
      SELF_EMPLOYED: 103,
      RETIRED: 105,
      MILITARY: 107,
      UNEMPLOYED: 109
    },
    BENEFICIARY_INFO: 79,
    COLLATERAL_VEHICLE: 84,
    COLLATERAL_REALESTATE: 86,
    COLLATERAL_CASH: 88,
    COLLATERAL_OTHER: 90,
    LOAN_DEMOGRAPHICS: 92,
    REFERENCES: 112,
    W8_DATA_COLLECTION: 117,
    WELCOME: 41
  },
  BRANCH: {
    ADDRESS: 3,
    DEMOGRAPHICS: 53,
    PERSON_INFO: 9,
    BUSINESS_INFO: 49,
    EMPLOYMENT: 51,
    EMPLOYMENT_HISTORY: {
      EMPLOYMENT_HISTORY: 78,
      EMPLOYED: 102,
      SELF_EMPLOYED: 104,
      RETIRED: 106,
      MILITARY: 108,
      UNEMPLOYED: 110
    },
    BENEFICIARY_INFO: 80,
    COLLATERAL_VEHICLE: 85,
    COLLATERAL_REALESTATE: 87,
    COLLATERAL_CASH: 89,
    COLLATERAL_OTHER: 91,
    LOAN_DEMOGRAPHICS: 93,
    REFERENCES: 111,
    W8_DATA_COLLECTION: 118
  },
});

export default UI_FIELDS_CATEGORIES;